import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiProviderUpdateFailedAction = {
	type: 'AI_PROVIDER_UPDATE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiProviderUpdateFailedAction => ({
	type: 'AI_PROVIDER_UPDATE_FAILED',
	payload,
});
